import { useQuery } from "@tanstack/react-query";
import { fetchContactsByCompany } from "../services/contactsServices";

const useContactsByCompany = (companyID) => {
  return useQuery({
    queryKey: ["contacts", companyID],
    queryFn: () => fetchContactsByCompany(companyID),
    enabled: !!companyID,
  });
};

export default useContactsByCompany;
